import { Box, Text, Image, Heading, Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ShowPracticeTestModal = () => {
	const navigate = useNavigate();
	return (
		<Box textAlign={'center'}>
			<Image mx="auto" src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Frame_1321317323_adfe5e88ce.svg" />
			<Heading color="#4358F6" as="h4" mt="16px">
				Practice Section Locked
			</Heading>
			<Box mt="10px" textAlign="center">
				<Text display={'inline'} textStyle={'body1-md'}>
					Attempt{' '}
					<Heading display={'inline'} color="#CC926E" as="h4">
						Know Your Level{' '}
					</Heading>
					test to unlock the practice section.
				</Text>
			</Box>
			<Button
				onClick={() => {
					navigate('/dashboard');
				}}
				bgColor={'#4358F6'}
				width={'100%'}
				variant={'primary'}
				mt="32px"
			>
				start test
			</Button>
		</Box>
	);
};

export default ShowPracticeTestModal;
